import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { apiService } from '../services/api';
import { Zap, Plus, Edit, Trash2 } from 'lucide-react';

export const Scenarios: React.FC = () => {
  const { t } = useTranslation('scenarios');
  const [scenarios, setScenarios] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchScenarios();
  }, []);

  const fetchScenarios = async () => {
    try {
      const response = await apiService.getScenarios();
      setScenarios(response || []);
    } catch (error) {
      console.error('Failed to fetch scenarios:', error);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <div className="loading-spinner">{t('noScenariosTitle')}</div>;
  }

  return (
    <div style={{ padding: '24px' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '24px',
        }}
      >
        <h2 style={{ fontSize: '24px', fontWeight: 600, margin: 0 }}>
          {t('title')}
        </h2>
        <button
          style={{
            background: '#3390ec',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            padding: '10px 16px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            fontSize: '14px',
            fontWeight: 500,
          }}
          onClick={() => alert('Create new scenario')}
        >
          <Plus size={16} />
          {t('newScenario')}
        </button>
      </div>

      {scenarios.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">⚡</div>
          <div className="empty-state-title">{t('noScenariosTitle')}</div>
          <div className="empty-state-description">
            {t('noScenariosDesc')}
          </div>
        </div>
      ) : (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
            gap: '16px',
          }}
        >
          {scenarios.map((scenario) => (
            <div
              key={scenario.id}
              style={{
                background: '#fff',
                borderRadius: '12px',
                padding: '20px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginBottom: '12px',
                }}
              >
                <div
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '10px',
                    background: '#ff950020',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#ff9500',
                  }}
                >
                  <Zap size={20} />
                </div>
                <div style={{ display: 'flex', gap: '4px' }}>
                  <button
                    style={{
                      background: 'transparent',
                      border: 'none',
                      cursor: 'pointer',
                      padding: '4px',
                    }}
                    title="Edit"
                  >
                    <Edit size={16} />
                  </button>
                  <button
                    style={{
                      background: 'transparent',
                      border: 'none',
                      cursor: 'pointer',
                      padding: '4px',
                      color: '#ff3b30',
                    }}
                    title="Delete"
                  >
                    <Trash2 size={16} />
                  </button>
                </div>
              </div>
              <div style={{ fontSize: '16px', fontWeight: 600, marginBottom: '8px' }}>
                {scenario.name}
              </div>
              <div style={{ fontSize: '14px', color: '#8e8e93', marginBottom: '12px' }}>
                {scenario.description || t('noDescription')}
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  fontSize: '12px',
                  color: '#8e8e93',
                }}
              >
                <span>{scenario.steps?.length || 0} {t('steps')}</span>
                <span
                  style={{
                    padding: '4px 8px',
                    borderRadius: '4px',
                    background: scenario.is_active ? '#34c75920' : '#8e8e9320',
                    color: scenario.is_active ? '#34c759' : '#8e8e93',
                  }}
                >
                  {scenario.is_active ? t('active') : t('inactive')}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
